import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

interface Props {
  hasRegularAccessOrNotEmployee: boolean
  hasOnboardingEnabled: boolean
}

const RootRedirects = ({ hasRegularAccessOrNotEmployee, hasOnboardingEnabled }: Props) => {
  const { navigation } = useNavigation()

  if (hasRegularAccessOrNotEmployee) {
    return <Navigate to={navigation.dashboard.path} />
  }

  if (!hasOnboardingEnabled) {
    return <Navigate to={navigation.profile.path} />
  }

  return <Navigate to={navigation.employee_onboarding.path} />
}

export default RootRedirects
